import { useEffect } from "react"
import { UseFormReset } from "react-hook-form"
import { useLocation } from "react-router-dom"
import { DateTime } from "luxon"
import { useTurnoActual } from "src/pages/home/room-detail/hooks/turnos"
import { FormValues } from "./RegistroIncidencia.types"
import { defaultValues } from "./RegistroIncidencia.constants"
import { useCurrentDateLazyQuery } from "src/gql/schema"
import { useDate } from "src/shared/hooks/useDate"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

export function useRegistroIncienciaConfig(
    turnos: any[],
    reset: UseFormReset<FormValues>
) {
    const turno = useTurnoActual()
    const location = useLocation()
    const [getDate] = useCurrentDateLazyQuery()
    const { UTCStringToLocalDate } = useDate()
    const { getTimezone } = useFormatDate()

    const fromCortes = location.pathname === "/u/cortes/crear-incidencia"

    useEffect(() => {
        if (turno?.turno_id && fromCortes) {
            getDate().then((d) => {
                reset({
                    ...defaultValues,
                    turn: turno?.turno_id,
                    date: [UTCStringToLocalDate(d.data?.serverDate)],
                })
            })
        }
    }, [turno?.turno_id])

    const getRegisterDate = async (selectedDate?: Date): Promise<string> => {
        const { data } = await getDate()

        if (!selectedDate) return data?.serverDate

        const zonehotel = getTimezone()
        const serverDateTime = DateTime.fromISO(data?.serverDate, { zone: zonehotel })
        // Componentes de calendario del día elegido en el DatePicker, anclados a la zona del hotel
        const selectedDateTime = DateTime.fromObject(
            {
                year: selectedDate.getFullYear(),
                month: selectedDate.getMonth() + 1,
                day: selectedDate.getDate(),
            },
            { zone: zonehotel }
        )
        const isSameDay = selectedDateTime.hasSame(serverDateTime, "day")

        if (isSameDay) return data?.serverDate

        // Para días distintos al actual, usar las 2pm del día seleccionado en la zona del hotel
        const dateAt2pm = selectedDateTime.set({ hour: 14, minute: 0, second: 0, millisecond: 0 })
        return dateAt2pm.toUTC().toISO() ?? ""
    }


    return {
        fromCortes,
        getRegisterDate,
    }
}
